import { Play, ExternalLink } from "lucide-react";
import { VIDEOS } from "../data";

export const Videos = () => {
  return (
    <section
      id="filmy"
      data-testid="videos-section"
      className="bg-white py-10 md:py-12 border-t border-zinc-200"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="font-anton uppercase text-zinc-400 tracking-widest text-xs">
            Materiały poglądowe
          </span>
          <h2 className="font-anton uppercase text-[#09090B] text-xl md:text-2xl mt-1 leading-tight">
            Przykładowe filmy pokazujące typ prac
          </h2>
          <p className="mt-2 text-zinc-500 text-sm">
            Poniższe filmy mają charakter poglądowy i pokazują przykładowy
            rodzaj prac wykonywanych sprzętem Bobcat.
          </p>
        </div>

        <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {VIDEOS.map((v, i) => (
            <a
              key={i}
              data-testid={`video-card-${i}`}
              href={v.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-3 border border-zinc-300 bg-zinc-50 p-2.5 hover:border-[#DC2626] transition-colors"
            >
              <div className="relative w-20 h-14 shrink-0 overflow-hidden">
                <img
                  src={v.thumb}
                  alt={v.title}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all"
                />
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="w-7 h-7 rounded-full bg-[#DC2626] flex items-center justify-center">
                    <Play className="text-white ml-0.5" size={14} fill="white" />
                  </span>
                </span>
              </div>
              <div className="min-w-0">
                <span className="font-anton uppercase text-[#09090B] text-sm leading-tight block truncate">
                  {v.title}
                </span>
                <span
                  data-testid={`video-button-${i}`}
                  className="mt-1 inline-flex items-center gap-1 text-[#DC2626] font-semibold uppercase tracking-wide text-xs"
                >
                  Zobacz przykład <ExternalLink size={12} />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};


